import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'textClean',
  standalone: true,
  pure: true,
})
export class TextCleanPipe implements PipeTransform {
  private static readonly CITE_REGEX = /\uE200cite\uE202[^\uE201]+\uE201/gu;

  transform(value: string | null | undefined): string {
    if (!value) return '';

    return value
      .replaceAll(TextCleanPipe.CITE_REGEX, '')
      .replaceAll(/\s{2,}/g, ' ')
      .replaceAll(/\(\[[^\]]+\]\([^)]+\)\)/g, '')
      .replaceAll(/(^|<br>)- /g, '$1• ')
      .trim();
  }
}
